export default __webpack_public_path__ + "static/G-SYNC-Compatible-2de3ffbf68ced52c832b2d64095aec66.webp";